require('./advancedBuySellWarrantSummary.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @hconstants
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_BUY_FOR_APPROX_IMPORT,
    BROKER_CONDITION_OVER_WARRANT_PRICE,
    BROKER_PRICE_GRATER_OR_EQUAL_CONDITION_ID,
    BROKER_PRICE_LESS_OR_EQUAL_CONDITION_ID,
    BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @commons
const WarrantsBuySellSummary = require('components/broker/commons/warrantsBuySellSummary/warrantsBuySellSummary');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

class AdvancedBuySellWarrantSummary extends React.Component {

    getOrderTermsDescription() {
        const { immBrokerWarrantsAdvancedState } = this.props;
        const step1 = immBrokerWarrantsAdvancedState.get('steps').get(FIRST_STEP);
        const conditionType = step1.get('conditionType');
        const conditionTypeValue = step1.get('conditionTypeValue');

        let result, stringResult;

        switch (conditionType) {
            case BROKER_PRICE_GRATER_OR_EQUAL_CONDITION_ID:
                result = <FormattedText value="broker-priceGraterOrEqualOrderTermsDescriptionWarrantsSummary" injectedStrings={[conditionTypeValue]} />
                stringResult = formatText('broker-priceGraterOrEqualOrderTermsDescriptionWarrantsSummary', [conditionTypeValue]);
                break;
            case BROKER_PRICE_LESS_OR_EQUAL_CONDITION_ID:
                result = <FormattedText value="broker-priceLessOrEqualOrderTermsDescriptionWarrantsSummary" injectedStrings={[conditionTypeValue]} />
                stringResult = formatText('broker-priceLessOrEqualOrderTermsDescriptionWarrantsSummary', [conditionTypeValue]);
                break;
            case BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                result = <FormattedText value="broker-dailyLoweringPercentageGraterThanOrderTermsDescriptionWarrantsSummary" injectedStrings={[conditionTypeValue]} />
                stringResult = formatText('broker-dailyLoweringPercentageGraterThanOrderTermsDescriptionWarrantsSummary', [conditionTypeValue]);
                break;
            case BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                result = <FormattedText value="broker-dailyRasingPercentageGraterThanOrderTermsDescriptionWarrantsSummary" injectedStrings={[conditionTypeValue]} />
                stringResult = formatText('broker-dailyRasingPercentageGraterThanOrderTermsDescriptionWarrantsSummary', [conditionTypeValue]);
                break;
            case BROKER_INTRADAY_DOWN_VARIATION_GRATER_THAN_CONDITION_ID:
                result = <FormattedText value="broker-intradayDownVariationGraterThanOrderTermsDescriptionWarrantsSummary" injectedStrings={[conditionTypeValue]} />
                stringResult = formatText('broker-intradayDownVariationGraterThanOrderTermsDescriptionWarrantsSummary', [conditionTypeValue]);
                break;
            case BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                result = <FormattedText value="broker-intradayDownVariationPercentageGraterThanOrderTermsDescriptionWarrantsSummary" injectedStrings={[conditionTypeValue]} />
                stringResult = formatText('broker-intradayDownVariationPercentageGraterThanOrderTermsDescriptionWarrantsSummary', [conditionTypeValue]);
                break;
            case BROKER_INTRADAY_UP_VARIATION_GRATER_THAN_CONDITION_ID:
                result = <FormattedText value="broker-intradayUpVariationGraterThanOrderTermsDescriptionWarrantsSummary" injectedStrings={[conditionTypeValue]} />
                stringResult = formatText('broker-intradayUpVariationGraterThanOrderTermsDescriptionWarrantsSummary', [conditionTypeValue]);
                break;
            case BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                result = <FormattedText value="broker-intradayUpVariationPercentageGraterThanOrderTermsDescriptionWarrantsSummary" injectedStrings={[conditionTypeValue]} />
                stringResult = formatText('broker-intradayUpVariationPercentageGraterThanOrderTermsDescriptionWarrantsSummary', [conditionTypeValue]);
                break;
            default:
                result = <div>{name}</div>
                break;
        }

        return {
            jsx: (
                <div className="advanced-buy-sell-warrant-summary__order-terms-block">{result}</div>
            ),
            string: stringResult
        };
    }

    constructSentence(step1, step2, immProductFile, isSell, orderTypeText) {
        const amount = step2.get('titleQuantity').toString();
        const buyFor = step2.get('buyFor');
        const warrantName = immProductFile.get('companyName');
        const limitPrice = step2.get('limitPrice').toString();

        const actionWord = isSell ?
            formatText('broker-warrantsAdvancedBuySummarySellWord') :
            formatText('broker-warrantsAdvancedBuySummaryBuyWord');

        let amountOrImport;
        const sentenceAmountText = formatText('broker-warrantsAdvancedBuyResumeSentenceAmount', [amount]);
        if (isSell) {
            amountOrImport = sentenceAmountText;
        } else {
            const buyForApproxImport = step2.get('buyForApproxImport');
            const sentenceApproImportText = formatText('broker-warrantsAdvancedBuyResumeSentenceApproxImport', [buyForApproxImport]);
            amountOrImport = buyFor === BROKER_BUY_FOR_APPROX_IMPORT ? sentenceApproImportText : sentenceAmountText;
        }

        const conditionType = this.getOrderTermsDescription().string.toLowerCase();
        const validityDate = step1.get('validityDate').format('DD MMM YYYY');

        return formatText("broker-warrantsAdvancedBuySummarySentence", [
            actionWord,
            amountOrImport,
            warrantName,
            limitPrice,
            orderTypeText,
            conditionType,
            validityDate
        ]);
    }

    render() {
        const { immProductFile,
                immBrokerWarrantsAdvancedState,
                immStocksContract,
                isSell } = this.props;

        const step1 = immBrokerWarrantsAdvancedState.getIn(['steps', FIRST_STEP]);
        const step2 = immBrokerWarrantsAdvancedState.getIn(['steps', SECOND_STEP]);
        const orderType = step1.get('orderType');
        const selectedOptionValue = step2.get('selectedOptionValue');
        const stockContract = immStocksContract.get(selectedOptionValue);
        const validityDate = step1.get('validityDate').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

        const typeAndValueOfConditionLabel = formatText('broker-warrantsAdvancedBuyTypeAndValueOfConditionLabel');
        const validityOfConditionLabel = formatText('broker-warrantsAdvancedBuyValidityOfConditionLabel');
        const resumeOfOperationLabel = formatText('broker-warrantsAdvancedBuyResumeOfOperationLabel');

        const orderTermsDescription = this.getOrderTermsDescription().jsx;


        let orderTypeText = formatText('broker-warrantsAdvancedBuySummaryConditionalUnderlyingPrice');
        if (orderType === BROKER_CONDITION_OVER_WARRANT_PRICE && !isSell) {
            orderTypeText = formatText('broker-warrantsAdvancedBuySummaryConditionalWarrantPrice');
        }
        if (orderType === BROKER_CONDITION_OVER_WARRANT_PRICE && isSell) {
            orderTypeText = formatText('broker-warrantsAdvancedSellSummaryConditionalWarrantPrice');
        }

        const sentence = this.constructSentence(step1, step2, immProductFile, isSell, orderTypeText.toLowerCase());

        return (
            <div className="advanced-buy-sell-warrant-summary">
                <OKInformativeList>
                    <OKInformativeListItem
                        title={resumeOfOperationLabel}
                        bodyText={sentence}
                        isUppercaseTitle={true}
                    />
                </OKInformativeList>
                <OKInformativeList>
                    <OKInformativeListItem
                        title={formatText('broker-advancedBuySellStockSummaryOrderTypeText')}
                        bodyText={orderTypeText}
                        isUppercaseTitle={true}
                    />
                </OKInformativeList>
                <OKInformativeList>
                    <OKInformativeListItem
                        title={typeAndValueOfConditionLabel}
                        isUppercaseTitle={true}
                    >
                        {orderTermsDescription}
                    </OKInformativeListItem>
                </OKInformativeList>
                <OKInformativeList>
                    <OKInformativeListItem
                        title={validityOfConditionLabel}
                        isUppercaseTitle={true}
                        bodyText={validityDate}
                    />
                </OKInformativeList>
                <FormattedText value="broker-advancedBuySellStockSummaryPurchaseOrderSummaryTitle" className="advanced-buy-sell-warrant-summary__purchase-order-summary-title" />
                <WarrantsBuySellSummary
                    stockContract={stockContract}
                    warrantFile={immProductFile}
                    step1={step1}
                    step2={step2}
                    isSell={isSell}
                />
            </div>
        );
    }
}

AdvancedBuySellWarrantSummary.propTypes = {
    immProductFile: PropTypes.object.isRequired,
    immBrokerWarrantsAdvancedState: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    isSell: PropTypes.bool
};

module.exports = AdvancedBuySellWarrantSummary;
